export default __webpack_public_path__ + "static/media/Singh.61e4fee4.png";